import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'ara-remaining-characters',
  templateUrl: './remaining-characters.component.html',
  styleUrls: ['./remaining-characters.component.css']
})
export class RemainingCharactersComponent implements OnInit, OnChanges {
  @Input()
  maxlength: number = 0;
  @Input()
  inputString: string = '';
  charsReamining: number;
  constructor() { }

  ngOnInit() {
  }
  ngOnChanges() {
    this.charsReamining = this.maxlength - this.inputString.length;
  }
}
